export const Routes = {
  homepage: "/",
  login: "/login",
  register: "/register",
  blog: "/blog",
  contactus: "/contact-us",
  aboutus: "/about-us",
  successstories: "/success-stories",
  verifyEmail: "/verify-email",
  forgotPassword: "/forgot-password",
  dashboard: "/dashboard",
  profile: "/profile",
  signup: "/sign-up",
  trainersignup: "/register/trainer",
  customersignup: "/register/customer",
  subscriptions: "/subscriptions",
  mamAdmin: "/mam-admin",
  trainerList: "/mam-admin/admin",
  customerList: "/mam-admin/trainer",
  addAdmin: "/mam-admin/add-admin",
  editAdmin: "/mam-admin/edit-admin",
  changepassword: "/change-password",
  trainer: "/trainer",
  addTrainer: "/trainer/add-trainer",
  editTrainer: "/trainer/edit-trainer/",
  trainersubscriptionplan: "/trainer-subscription",
  customersubscriptionplan: "/customer-subscription",

  customer: "/customer",
  addCustomer: "/customer/add-customer",
  editCustomer: "/customer/edit-customer/",
  customerplanrequesttoadmin: "/customer-admin-request",
  customeradminplandetails: "/customer-admin-request/request-details/",
  customertrainerplandetails: "/customer-trainer-request/request-details/",
  customerplanrequesttotrainer: "/customer-trainer-request",
  customerRemoveRequest: "/customer-remove-request",

  dietPlan: "/diet-plan",
  addDietPlan: "/diet-plan/add-diet-plan",
  editDietPlan: "/diet-plan/edit-diet-plan/",

  customerDashbaord: "/customer-dashbaord",
  managePlans: "/manage-plans",
  manageCoupons: "/manage-coupons",
  reports: "/reports",
  userManagement: "/user-management",
  calculators: "/calculators",
  message: "/message",

  manageStripePlans: "/managestripe-plans",

  subscriptionPlan: "/subscription-plans",
  subscriptionPlanPersonalized: "/subscription-plans/personalized",
  subscriptionPayment: "/subscriptionpayment",
  transferAdmin: "/transfer-admin",
  request: "/sign-up-request",
  mealplantemplate: "/template-plan",
  managefoods: "/manage-foods",
  createfood: "/manage-foods/create-food",
  editfood: "manage-foods/edit-food/",
  addmealplantemplate: "/template-plan/edit-template-plan",
  editmealplantemplate: "/template-plan/edit-template-plan/",
  shoppingList: "/shopping-list",
  alltransactionlist: "/all-transaction",
  customerPlanByTrainer: "/customer/",
  plan: "/plan/",
  referral: "/referrals",
  createDietPlan: "/diet-plan/create",
  create: "/create",
  createTemplatePlan: "/template-plan/create/fresh-start",
  createDietPlanFromScratch: "/diet-plan/create/fresh-start",
  planfromScratch: "/create/fresh-start",
  editRecipe: "/recipe/edit-recipe/",
  recipeview: "/recipe/view-recipe/",

  recipe: "/recipe",
  createRecipe: "/recipe/create",
  createRecipeFromScratch: "/recipe/create/new-recipe",
  customersubscriptions: "/customersubscriptions",
  rewards: "/rewards",
  faq: "/faq",
  foodconfiguration: "/foodconfiguration",

  // Blog (public "blog" route already existed above; these are the admin management screens)
  manageBlog: "/manage-blog",
  createBlogPost: "/manage-blog/create",
  editBlogPost: "/manage-blog/edit/",
  blogDetails: "/blog/",

  // Public Calculators
  publicCalculator: "/public-calculator?type=bmr",
  bmrCalculator: "/public-calculator?type=bmr",
  tdeeCalculator: "/public-calculator?type=tdee",
};

export const PUBLIC_ROUTES = [
  "/",
  "/faq",
  "/blog",
  "/contact-us",
  "/about-us",
  "/success-stories",
  "/login",
  "/terms-condition",
  "/home-page",
  "/register",
  "/verify-email",
  "/forgot-password",
  "/terms-condition",
  "/privacy-policy",
  "/register/trainer",
  "/register/customer",
  "/subscriptions",
  "/customersubscriptions",
  "/blog/",
  "/public-calculator",
];

export const noFooterPath = [
  "/",
  "/faq",
  "/blog",
  "/contact-us",
  "/about-us",
  "/success-stories",
  "/login",
  "/forgot-password",
  "/terms-condition",
  "/privacy-policy",
  "/register",
  "/register/trainer",
  "/register/customer",
  "/subscriptions",
  "/customersubscriptions",
  "/public-calculator",
];
